import React from 'react';

// @ts-ignore
const NotificationContext = React.createContext();

export default NotificationContext;
